import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "/",
  class: "flex-shrink-0 breadcrumb-offset-reference"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import logoDark from "../../../../../../../../public/img/logo.dark.svg";
import logoLight from "../../../../../../../../public/img/logo.light.svg";

export default /*@__PURE__*/_defineComponent({
  __name: 'BrandLogo',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(logoLight),
      alt: "4programmers.net",
      class: "h-6.5 dark:hidden"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("img", {
      src: _unref(logoDark),
      alt: "4programmers.net",
      class: "h-6.5 hidden dark:block"
    }, null, 8 /* PROPS */, _hoisted_3)
  ]))
}
}

})